<template>
  <v-dialog
    v-model="powerPlantDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-toolbar dark color="#7C3DFF">
                <v-toolbar-title class="m-0 white--text"
                  >Dados da Usina</v-toolbar-title
                >
                <v-spacer />
                <v-toolbar-items>
                  <v-btn icon dark flat @click="setPowerPlantDialog(false)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card>
                  <v-card-title class="pb-0">
                    <v-container grid-list-md class="pb-0">
                      <v-layout wrap>
                        <p class="headline font-weight-bold pl-2">
                          {{ type === "new" ? "Adicionar" : "Editar" }} Usina
                        </p>
                      </v-layout>
                    </v-container>
                  </v-card-title>

                  <v-card-text class="pt-0">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md3>
                          <v-text-field
                            label="Nome*"
                            v-model="name"
                            :rules="[
                              (v) =>
                                !!v || 'Por favor, informe o nome da usina!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-text-field
                            label="ID da Usina*"
                            v-model="id"
                            :rules="[
                              (v) => !!v || 'Por favor, informe o ID da usina!',
                            ]"
                            required
                            :disabled="type === 'edit'"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field
                            label="Número de Instalação"
                            v-model="installationNumber"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-autocomplete
                            label="Status"
                            v-model.lazy="status"
                            :items="statusList"
                            item-text="text"
                            item-value="value"
                          />
                        </v-flex>

                        <v-flex xs12 sm6 md2>
                          <v-autocomplete
                            label="Concessionária*"
                            v-model.lazy="utility_company"
                            :items="utilityCompanies"
                            item-text="name"
                            item-value="id"
                            :rules="[
                              (v) =>
                                !!v || 'Por favor, informe a concessionária!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field
                            label="Potência*"
                            v-model="power"
                            :rules="[
                              (v) =>
                                !!v ||
                                'Por favor, informe a potência da usina!',
                            ]"
                            type="number"
                            prefix="kW"
                            @keydown="handleKeyDown"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field
                            label="Performance Alvo"
                            v-model.number="powerMonthly"
                            type="number"
                            prefix="kWh"
                            @keydown="handleKeyDown"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-autocomplete
                            label="Tipo da usina*"
                            v-model.lazy="power_plant_type"
                            :items="powerPlantTypeList"
                            item-text="text"
                            item-value="value"
                            :rules="[
                              (v) =>
                                !!v || 'Por favor, informe o tipo da usina!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-autocomplete
                            label="Modalidade de tarifa*"
                            v-model.lazy="fare_modality"
                            :items="fareModalityList"
                            item-text="text"
                            item-value="value"
                            :rules="[
                              (v) =>
                                !!v ||
                                'Por favor, informe a modalidade de tarifa!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-autocomplete
                            label="Serviço de Pagamento*"
                            v-model.lazy="paymentService"
                            :items="paymentServiceList"
                            item-text="text"
                            item-value="value"
                            :rules="[
                              (v) =>
                                !!v ||
                                'Por favor, selecione o serviço de pagamento utilizado!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field
                            label="Prazo para Ativação*"
                            v-model="prazo"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md5>
                          <v-text-field
                            label="URL do Logo da Usina"
                            v-model="logoUrl"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md5>
                          <v-text-field
                            label="Endereço Completo"
                            v-model="adress"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            label="E-mail 1 (obrigatório)*"
                            v-model="email"
                            :rules="[rules.required, rules.email]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            label="E-mail 2 (opcional)"
                            v-model="optional_email"
                            :rules="[(v) => !v || rules.email(v)]"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field label="Telefone" v-model="phone" />
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            label="Nome do Gestor"
                            v-model="manager_name"
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-text-field
                            label="Dia do Pagamento do Lote"
                            v-model="batchPaymentDay"
                            type="number"
                            hint="O dia pode ser 5, 15 ou 25"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-menu
                            v-model="calendarContractEnd"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="powerPlantContractEnd"
                                label="Vencimento do Contrato"
                                prepend-icon="event"
                                readonly
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              dark
                              v-model="powerPlantContractEnd"
                              @input="calendarContractEnd = false"
                            />
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-autocomplete
                            label="Empresa"
                            v-model="company"
                            :items="companies"
                            item-text="text"
                            item-value="value"
                            :rules="[
                              (v) => !!v || 'Por favor, informe a empresa!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-autocomplete
                            label="Modalidade de Geração"
                            v-model="generation_modality"
                            :items="generation_modalities"
                            item-text="text"
                            item-value="value"
                            :rules="[
                              (v) =>
                                !!v ||
                                'Por favor, informe a modalidade de geração!',
                            ]"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout wrap class="layoutBorder pa-2">
                            <v-flex xs12>
                              <span class="font-weight-bold">Contrato</span>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-autocomplete
                                label="Modelo do Contrato"
                                v-model.lazy="contract_model"
                                :items="modelContractList"
                              />
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              md3
                              v-if="contract_model === 'PPA'"
                            >
                              <v-text-field
                                label="% de Deságio"
                                type="number"
                                v-model="discount"
                                :rules="[
                                  (value) =>
                                    (value >= 0 && value <= 100) ||
                                    'Insira um valor entre 0 e 100',
                                ]"
                                required
                              />
                              <div class="green--text text--lighten-1 caption">
                                % aplicado em cima da tarifa compensável B3
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6 md3 v-if="contract_model === 'TF'">
                              <v-text-field
                                label="%  Fee"
                                type="number"
                                v-model="fee"
                                :rules="[
                                  (value) =>
                                    (value >= 0 && value <= 100) ||
                                    'Insira um valor entre 0 e 100',
                                ]"
                                required
                              />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-text-field
                                label="Código da pasta Legal One"
                                v-model="code_legal_one"
                                :rules="[
                                  (v) => !!v || 'Por favor, informe o código!',
                                ]"
                                required
                              />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-btn
                                @click="showContractModal"
                                color="primary"
                                block
                              >
                                CONTRATOS
                              </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-text-field
                                label="Prazo de Pagamento"
                                type="number"
                                v-model="payment_term"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'Por favor, informe o Prazo de Pagamento!',
                                ]"
                                required
                              />
                            </v-flex>

                            <!-- alterar models -->
                            <v-flex xs12 sm6 md3>
                              <v-menu
                                v-model="calendarAccepted"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="acceptedUtillityCompanies"
                                    label="Aceite na concessionária"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  dark
                                  v-model="acceptedUtillityCompanies"
                                  @input="calendarAccepted = false"
                                />
                              </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-menu
                                v-model="calendarFirstPayment"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="firstPayment"
                                    label="Primeiro Pagamento da Usina"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  dark
                                  v-model="firstPayment"
                                  @input="calendarFirstPayment = false"
                                />
                              </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                              <v-btn
                                @click="showDocumentModal"
                                color="primary"
                                block
                              >
                                DOCUMENTOS
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 md2>
                          <v-checkbox
                            label="Está em faturamento?"
                            v-model="activeBilling"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                          <v-checkbox
                            label="Possui split?"
                            v-model="hasSplit"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm6 md4 v-if="showMonitoringPlatformLogin">
                          <v-checkbox
                            label="Usina possui plataforma de monitoramento de geração?"
                            v-model="hasMonitoringPlatform"
                          />
                        </v-flex>

                        <v-layout
                          class="px-3"
                          column
                          wrap
                          v-if="
                            hasMonitoringPlatform ||
                            !showMonitoringPlatformLogin
                          "
                        >
                          <div class="font-weight-bold">
                            Dados de acesso a plataforma de monitoramento de
                            geração
                          </div>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                label="URL"
                                v-model="monitoring_platform.url"
                                append-icon="content_copy"
                                @click:append="
                                  copyText(monitoring_platform.url)
                                "
                                required
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'Por favor, informe a URL da plataforma de monitoramento!',
                                ]"
                              />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                label="Login"
                                v-model="monitoring_platform.login"
                                append-icon="content_copy"
                                @click:append="
                                  copyText(monitoring_platform.login)
                                "
                                required
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'Por favor, informe o login de acesso!',
                                ]"
                              />
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-text-field
                                label="Senha"
                                v-model="monitoring_platform.password"
                                append-icon="content_copy"
                                @click:append="
                                  copyText(monitoring_platform.password)
                                "
                                required
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'Por favor, informe a senha de acesso!',
                                ]"
                              />
                            </v-flex>
                          </v-layout>
                        </v-layout>

                        <v-flex xs12 sm12 md12>
                          <div class="report-title">
                            <div class="font-weight-bold no_space">
                              Expectativa de Geração pelo PVSyst
                            </div>
                            <div class="no_space">
                              <a
                                v-if="pvsyst_report_link"
                                target="_blank"
                                :href="pvsyst_report_link"
                                class="report_link no_space"
                                ><v-icon size="16">mdi-file</v-icon> Visualizar
                                Relatório PVSyst
                              </a>

                              <div v-else class="no_space">
                                <button
                                  v-if="pvsyst_report.name"
                                  @click.prevent="removePvsystContract()"
                                  class="report_link pr-2 pt-1"
                                >
                                  {{ pvsyst_report.name }}
                                  <v-icon
                                    size="18"
                                    color="black"
                                    class="ml-1 close-icon"
                                    >mdi-close</v-icon
                                  >
                                </button>
                                <button
                                  v-else
                                  @click.prevent="pickPvsystReport"
                                  class="report_link"
                                >
                                  <v-icon size="16">upload</v-icon>
                                  Anexar Relatório PVSyst
                                </button>
                              </div>
                              <input
                                type="file"
                                ref="pvsyst_report"
                                style="display: none"
                                @change="pickedPvsystReport($event)"
                                accept="image/*, application/pdf"
                              />
                            </div>
                          </div>
                        </v-flex>
                        <v-layout row wrap class="px-3">
                          <v-flex
                            xs12
                            sm4
                            md2
                            v-for="(item, index) in PVSystExpectation"
                            :key="index"
                          >
                            <p class="font-weight-bold">{{ item.month }}</p>
                            <v-text-field
                              v-model="item.energy"
                              type="number"
                              prefix="MWh"
                              class="pt-0"
                              :readonly="hasExpectation"
                              @change="formatNumber(item)"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      flat
                      color="success"
                      @click="validate"
                      :loading="loading"
                      :disabled="buttonDisable()"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>

                  <v-snackbar :color="snackColor" top v-model="snackbar" dark>
                    <span>{{ snackMessage }}</span>
                    <v-icon size="16" @click="snackbar = false">
                      mdi-close-circle
                    </v-icon>
                  </v-snackbar>
                </v-card>
              </v-form>
            </v-card>
          </v-flex>

          <v-flex xs12 v-if="hasSplit && type === 'edit'">
            <split-list
              v-if="hasSplit && type === 'edit'"
              :powerPlantId="powerPlantId"
              :split="split"
            />
          </v-flex>
        </v-layout>
        <PowerPlantDocumentModal ref="documentModal" />
        <PowerPlantContractModal ref="contractModal" />
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import splitList from "@/components/configuration/SplitList.vue";
import PowerPlantDocumentModal from "./PowerPlantDocumentModal.vue";
import PowerPlantContractModal from "./PowerPlantContractModal.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { uploadPvsystReport } from "@/services/powerplants.js";

export default {
  props: {
    type: {
      type: String,
      default: "new",
    },
    powerPlantId: {
      type: String,
      default: "",
    },
  },

  components: { splitList, PowerPlantDocumentModal, PowerPlantContractModal },

  data: () => ({
    rules: {
      required: (v) => !!v || "Campo obrigatório",
      email: (v) =>
        (v && !!v.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) ||
        "O campo precisa ser um email",
    },
    valid: false,
    loading: false,
    snackbar: false,
    activeBilling: false,
    hasSplit: false,
    powerPlantContractEnd: null,
    acceptedUtillityCompanies: null,
    firstPayment: null,
    calendarContractEnd: false,
    calendarAccepted: false,
    calendarFirstPayment: false,
    companies: [
      { text: "Elétron", value: "eletron" },
      { text: "Juntos", value: "juntos" },
    ],
    generation_modalities: [
      { text: "Autoconsumo Remoto", value: "remote_self_consumption" },
      { text: "Geração Compartilhada", value: "shared_generation" },
    ],
    company: null,
    generation_modality: null,
    batchPaymentDay: null,
    search: "",
    name: "",
    id: "",
    status: "",
    power: "",
    powerMonthly: "",
    installationNumber: "",
    prazo: "",
    logoUrl: "",
    adress: "",
    contract_model: "",
    power_plant_type: "",
    fare_modality: "",
    utility_company: "",
    paymentService: "",
    email: "",
    optional_email: "",
    phone: "",
    manager_name: "",
    snackMessage: "",
    snackColor: "",
    contract: {
      name: "",
      data: null,
    },
    pvsyst_report: {
      name: "",
      data: null,
    },
    photos: {
      name: "",
      data: null,
    },
    paymentServiceList: [{ text: "Pagarme", value: "pagarme" }],
    statusList: [
      { text: "Ativo", value: "activated" },
      { text: "Em Construção", value: "construction" },
      { text: "Aguardando", value: "waiting" },
      { text: "Em Operação", value: "operating" },
      { text: "Contrato Encerrado", value: "contract_terminated" },
      { text: "Renegociação", value: "renegotiation" },
      { text: "Análise Jurídica", value: "legal_analysis" },
      { text: "Cancelada", value: "canceled" },
    ],
    modelContractList: ["PPA", "TF"],
    discount: null,
    fee: null,
    code_legal_one: "",
    payment_term: null,
    powerPlantTypeList: ["mini", "micro"],
    fareModalityList: ["GDI", "GDII", "GDIII"],
    hasMonitoringPlatform: false,
    showMonitoringPlatformLogin: true,
    monitoring_platform: {
      url: null,
      login: null,
      password: null,
    },
    PVSystExpectation: [
      { month: "Jan", energy: null },
      { month: "Fev", energy: null },
      { month: "Mar", energy: null },
      { month: "Abr", energy: null },
      { month: "Mai", energy: null },
      { month: "Jun", energy: null },
      { month: "Jul", energy: null },
      { month: "Ago", energy: null },
      { month: "Set", energy: null },
      { month: "Out", energy: null },
      { month: "Nov", energy: null },
      { month: "Dez", energy: null },
    ],
    hasExpectation: false,
    pvsyst_report_link: null,
  }),

  computed: {
    ...mapState("configuration", ["powerPlantDialog", "utilityCompanies"]),
    ...mapState(["user"]),
    ...mapGetters("configuration", ["powerPlantById"]),

    powerPlant() {
      return this.powerPlantId ? this.powerPlantById(this.powerPlantId) : {};
    },

    split() {
      return this.powerPlant ? this.powerPlant.split : [];
    },
  },

  async mounted() {
    if (this.utilityCompanies?.length <= 0) this.getUtilityCompanies();

    this.loading = true;
    this.name = this.powerPlant.name ?? "";
    this.generation_modality = this.powerPlant.generation_modality ?? null;
    this.id = this.powerPlantId;
    this.installationNumber = this.powerPlant.installation_number ?? "";
    this.status = this.powerPlant.status ?? "";
    this.power = this.powerPlant.power ?? "";
    this.powerMonthly = this.powerPlant.power_monthly ?? "";
    this.logoUrl = this.powerPlant.main_image ?? "";
    this.adress = this.powerPlant.adress ?? "";
    this.paymentService = this.powerPlant.payment_service ?? "pagarme";
    this.prazo = this.powerPlant.prazo ?? "";
    this.batchPaymentDay = this.powerPlant.batch_payment_day;
    this.contract_model = this.powerPlant.contract_model ?? "PPA";
    ((this.discount = this.powerPlant.discount
      ? this.powerPlant.discount * 100
      : null),
      (this.fee = this.powerPlant.fee ? this.powerPlant.fee * 100 : null),
      (this.code_legal_one = this.powerPlant.code_legal_one ?? ""),
      (this.payment_term = this.powerPlant.payment_term ?? ""),
      (this.power_plant_type = this.powerPlant.type ?? ""));
    this.fare_modality = this.powerPlant.fare_modality ?? "";
    this.utility_company = this.powerPlant.utility_company ?? "";
    this.email = this.powerPlant.email ?? "";
    this.optional_email = this.powerPlant.optional_email ?? "";
    this.phone = this.powerPlant.phone ?? "";
    this.manager_name = this.powerPlant.manager_name ?? "";
    this.activeBilling = this.powerPlant.active_billing ?? false;
    this.hasSplit = this.powerPlant.has_split ?? false;
    this.powerPlantContractEnd = this.powerPlant.contract_end
      ? moment(this.powerPlant.contract_end.toDate()).format("YYYY-MM-DD")
      : null;
    this.acceptedUtillityCompanies = this.powerPlant.accepted_utillity_companies
      ? moment(this.powerPlant.accepted_utillity_companies.toDate()).format(
          "YYYY-MM-DD",
        )
      : null;
    this.firstPayment = this.powerPlant.first_payment
      ? moment(this.powerPlant.first_payment.toDate()).format("YYYY-MM-DD")
      : null;

    if (this.powerPlant.name) {
      this.company = this.powerPlant.company
        ? this.powerPlant.company
        : "juntos";
    }

    if (this.powerPlant.monitoring_platform) {
      this.showMonitoringPlatformLogin = false;
      this.monitoring_platform = JSON.parse(
        JSON.stringify(this.powerPlant.monitoring_platform),
      );
    }

    if (this.powerPlant.pvsyst_expectation) {
      this.hasExpectation = true;
      this.PVSystExpectation = JSON.parse(
        JSON.stringify(this.powerPlant.pvsyst_expectation),
      );
    }

    if (this.id) {
      const report = await this.getPvsystReport({ id: this.id });
      this.pvsyst_report_link = report ? report.url : null;
    }

    this.loading = false;
  },

  methods: {
    ...mapActions("configuration", [
      "addPlants",
      "updatePlants",
      "getPvsystReport",
      "getUtilityCompanies",
    ]),
    ...mapMutations("configuration", ["setPowerPlantDialog"]),

    copyText(text) {
      navigator.clipboard.writeText(text);
      this.snack("Copiado para área de transferência", "green");
    },

    formatNumber(objeto) {
      objeto.energy = parseFloat(objeto.energy).toFixed(1);
    },

    handleKeyDown(event) {
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    },

    snack(message, color) {
      this.snackColor = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    buttonDisable() {
      return (
        !this.valid ||
        this.name === "" ||
        this.id === "" ||
        this.power === "" ||
        this.paymentService === "" ||
        this.prazo === "" ||
        this.loading
      );
    },

    showDocumentModal() {
      if (!this.id || this.id == "") {
        this.snack("Informe o ID da usina antes de anexar arquivos!", "red");
        return;
      }
      this.$refs.documentModal.showDocumentModal(this.id);
    },

    showContractModal() {
      if (!this.id || this.id == "" || !this.status || this.status == "") {
        this.snack(
          "Informe o ID e o status da usina antes de anexar contratos!",
          "red",
        );
        return;
      }
      this.$refs.contractModal.showContractModal(this.id, this.status);
    },

    pickPvsystReport() {
      this.$refs.pvsyst_report.click();
    },

    pickedPvsystReport(event) {
      const contractFile = event.target.files;
      if (contractFile[0] !== undefined) {
        const allowedExtensions = [".pdf", ".png", ".jpeg", ".jpg"];
        const isValidExtension = allowedExtensions.some((ext) =>
          contractFile[0].name.includes(ext),
        );
        if (!isValidExtension) {
          this.snack("O arquivo deve ser PDF, PNG ou JPEG!", "red");
          return;
        }
        this.pvsyst_report.name = contractFile[0].name;
        this.pvsyst_report.data = [...contractFile];
      }
    },

    removePvsystContract() {
      this.pvsyst_report.name = "";
      this.pvsyst_report.data = null;
      this.$refs.pvsyst_report.value = "";
    },

    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        const data = {
          name: this.name.trim(),
          company: this.company,
          generation_modality: this.generation_modality,
          status: this.status || "activated",
          batch_payment_day: +this.batchPaymentDay,
          contract_model: this.contract_model,
          discount: this.discount ? this.discount / 100 : null,
          fee: this.fee ? this.fee / 100 : null,
          code_legal_one: this.code_legal_one,
          payment_term: this.payment_term,
          id: this.id.trim(),
          power_plant_id: this.id.trim(),
          power: this.power,
          power_monthly: parseInt(this.powerMonthly),
          installation_number: this.installationNumber.trim(),
          active_billing: this.activeBilling,
          payment_service: this.paymentService,
          prazo: this.prazo,
          has_split: this.hasSplit,
          main_image: this.logoUrl,
          adress: this.adress,
          type: this.power_plant_type,
          utility_company: this.utility_company,
          fare_modality: this.fare_modality,
          email: this.email.trim(),
          optional_email: this.optional_email.trim(),
          phone: this.phone.trim(),
          manager_name: this.manager_name,
          contract_end: this.powerPlantContractEnd
            ? moment(this.powerPlantContractEnd).toDate()
            : null,
          accepted_utillity_companies: this.acceptedUtillityCompanies
            ? moment(this.acceptedUtillityCompanies).toDate()
            : null,
          first_payment: this.firstPayment
            ? moment(this.firstPayment).toDate()
            : null,
        };

        const totalExpectation = this.PVSystExpectation.reduce((prev, cur) => {
          if (cur.energy !== null && cur.energy > 0) {
            return prev + 1;
          } else {
            return prev;
          }
        }, 0);

        if (totalExpectation > 0) {
          if (totalExpectation !== this.PVSystExpectation.length) {
            this.loading = false;
            this.snack(
              "Preencha a Expectativa de Geração pelo PVSyst de todos os meses!",
              "red",
            );
            return;
          }
          data.pvsyst_expectation = this.PVSystExpectation;
        }

        if (this.hasMonitoringPlatform || !this.showMonitoringPlatformLogin) {
          data.monitoring_platform = this.monitoring_platform;
        }

        if (this.pvsyst_report.data) {
          try {
            const data = {
              id: this.powerPlantId,
              data: this.pvsyst_report.data,
              agent_email: this.user?.email || "unknown",
            };
            await uploadPvsystReport(data);
          } catch (error) {
            console.error(error);
            this.loading = false;
            this.snack("Erro ao realizar upload do Relatório PVSyst!", "red");
            return;
          }
        }

        if (this.type === "new") await this.addPlants(data);
        else if (this.type === "edit") await this.updatePlants(data);

        this.setPowerPlantDialog(false);
      } else {
        this.snack("Preencha todos os campos obrigatórios!", "red");
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.report-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.report_link {
  min-width: fit-content;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 20px;
  border: 1px solid #000;
  color: #000;
  transition: 0.4s;
  &:hover {
    background: #f5f5f5;
  }
  .close-icon {
    transform: translateY(2px);
  }
}
.no_space {
  display: inline;
}

.layoutBorder {
  border: 1px solid #efefef !important;
}
</style>
